import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";

export default function SideBar(props) {
  const [menuRelatoriosAberto, setMenuRelatoriosAberto] = useState(false);
  const [exibirRelatoriosAgrupados, setExibirRelatoriosAgrupados] =
    useState(true);
  const [itensMenu, setItensMenu] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("menuEncolhido") === "true") {
      setExibirRelatoriosAgrupados(false);
    } else {
      setExibirRelatoriosAgrupados(true);
    }
  }, []);

  useEffect(() => {
      setItensMenu(JSON.parse(localStorage.getItem('perfil')).modulos.map((it) => it.modulo))
  }, []);

  return (
    <React.Fragment>
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          {itensMenu.includes("/dashboard") && (
            <li
              className={`nav-item ${
                props.itemActive === "dashboard" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/dashboard">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-home"
                    style={{ fontSize: "22px" }}
                    id="item-dashboard"
                  ></i>

                  <UncontrolledTooltip
                    placement="right"
                    target={`item-dashboard`}
                  >
                    Dashboard
                  </UncontrolledTooltip>

                  {localStorage.getItem("menuEncolhido") === true && (
                    <React.Fragment>
                      <i
                        className="fa fa-home"
                        style={{ fontSize: "28px" }}
                        id="teste"
                      ></i>
                    </React.Fragment>
                  )}
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Dashboard</span>
              </Link>
            </li>
          )}

          {itensMenu.includes("/pedidos-novo") && (
            <li
              className={`nav-item ${
                props.itemActive === "novoPedido" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/pedidos-novo">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-plus"
                    style={{ fontSize: "22px" }}
                    id="item-new-pedido"
                  ></i>

                  <UncontrolledTooltip
                    placement="right"
                    target={`item-new-pedido`}
                  >
                    Novo Pedido
                  </UncontrolledTooltip>

                  {localStorage.getItem("menuEncolhido") === true && (
                    <React.Fragment>
                      <i
                        className="fa fa-user-plus"
                        style={{ fontSize: "28px" }}
                        id="teste"
                      ></i>
                    </React.Fragment>
                  )}
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Novo Pedido</span>
              </Link>
            </li>
          )}

          {itensMenu.includes("/consulta-pedidos") && (
            <li
              className={`nav-item ${
                props.itemActive === "pedidos" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/pedidos">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-search"
                    id="item-pedidos"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Pedidos</span>
                <UncontrolledTooltip placement="right" target={`item-pedidos`}>
                  Pedidos
                </UncontrolledTooltip>
              </Link>
            </li>
          )}

          {itensMenu.includes("/consulta-orcamentos") && (
            <li
              className={`nav-item ${
                props.itemActive === "orcamentos" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/orcamentos">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-search"
                    id="item-orcamentos"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Orçamentos</span>
                <UncontrolledTooltip
                  placement="right"
                  target={`item-orcamentos`}
                >
                  Orçamentos
                </UncontrolledTooltip>
              </Link>
            </li>
          )}

          {itensMenu.includes("/clientes-novo") && (
            <li
              className={`nav-item ${
                props.itemActive === "newClient" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/novoClientes">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-user-plus"
                    style={{ fontSize: "22px" }}
                    id="item-new-client"
                  ></i>

                  <UncontrolledTooltip
                    placement="right"
                    target={`item-new-client`}
                  >
                    Novo Cliente
                  </UncontrolledTooltip>

                  {localStorage.getItem("menuEncolhido") === true && (
                    <React.Fragment>
                      <i
                        className="fa fa-user-plus"
                        style={{ fontSize: "28px" }}
                        id="teste"
                      ></i>
                    </React.Fragment>
                  )}
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Novo Cliente</span>
              </Link>
            </li>
          )}

          {itensMenu.includes("/clientes") && (
            <li
              className={`nav-item ${
                props.itemActive === "carteira" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/carteira-clientes">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-user"
                    id="item-carteira"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Carteira de Clientes</span>
                <UncontrolledTooltip placement="right" target={`item-carteira`}>
                  Carteira de Clientes
                </UncontrolledTooltip>
              </Link>
            </li>
          )}

          {/* <li
            className={`nav-item ${
              props.itemActive === "produtoDestaque" ? "active" : ""
            }`}
          >
            <Link className="nav-link" to="/produtos-destaque">
              <span style={{ minWidth: "30px", textAlign: "center" }}>
                <i
                  className="fa fa-star"
                  style={{ fontSize: "22px" }}
                  id="item-produto-destaque"
                ></i>

                <UncontrolledTooltip
                  placement="right"
                  target={`item-produto-destaque`}
                >
                  Produtos em Destaque
                </UncontrolledTooltip>

                {localStorage.getItem("menuEncolhido") === true && (
                  <React.Fragment>
                    <i
                      className="fa fa-star"
                      style={{ fontSize: "28px" }}
                      id="item-produto-destaque"
                    ></i>
                  </React.Fragment>
                )}
              </span>
              &nbsp;&nbsp;
              <span className="menu-title">Produtos em Destaque</span>
            </Link>
          </li> */}

          {itensMenu.includes("/historico-faturamento") && (
            <li
              className={`nav-item ${
                props.itemActive === "historicoVenda" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/historicoVenda">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-list-ul"
                    style={{ fontSize: "22px" }}
                    id="item-hist-venda"
                  ></i>

                  <UncontrolledTooltip
                    placement="right"
                    target={`item-hist-venda`}
                  >
                    Histórico de Faturamento Item
                  </UncontrolledTooltip>

                  {localStorage.getItem("menuEncolhido") === true && (
                    <React.Fragment>
                      <i
                        className="fa fa-list-ul"
                        style={{ fontSize: "28px" }}
                        id="item-hist-venda"
                      ></i>
                    </React.Fragment>
                  )}
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">
                  Histórico de Faturamento Item
                </span>
              </Link>
            </li>
          )}
          {itensMenu.includes("/historico-faturamento") && (
            <li
              className={`nav-item ${
                props.itemActive === "historicoVendaCapa" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/historico-faturamento-capa">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-list-ul"
                    style={{ fontSize: "22px" }}
                    id="item-hist-venda2"
                  ></i>

                  <UncontrolledTooltip
                    placement="right"
                    target={`item-hist-venda2`}
                  >
                    Histórico de Faturamento
                  </UncontrolledTooltip>

                  {localStorage.getItem("menuEncolhido") === true && (
                    <React.Fragment>
                      <i
                        className="fa fa-list-ul"
                        style={{ fontSize: "28px" }}
                        id="item-hist-venda"
                      ></i>
                    </React.Fragment>
                  )}
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Histórico de Faturamento</span>
              </Link>
            </li>
          )}

          {itensMenu.includes("/titulos-atraso") && (
            <li
              className={`nav-item ${
                props.itemActive === "titulosAtraso" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/titulos-atraso">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-list-ul"
                    style={{ fontSize: "22px" }}
                    id="item-titulo-atraso"
                  ></i>

                  <UncontrolledTooltip
                    placement="right"
                    target={`item-titulo-atraso`}
                  >
                    Títulos em Atraso
                  </UncontrolledTooltip>

                  {localStorage.getItem("menuEncolhido") === true && (
                    <React.Fragment>
                      <i
                        className="fa fa-list-ul"
                        style={{ fontSize: "28px" }}
                        id="item-titulo-atraso"
                      ></i>
                    </React.Fragment>
                  )}
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Títulos em Atraso</span>
              </Link>
            </li>
          )}

          {/* <li
            className={`nav-item ${
              props.itemActive === "programacao" ? "active" : ""
            }`}
          >
            <Link className="nav-link" to="/lista-programacao">
              <span style={{ minWidth: "30px", textAlign: "center" }}>
                <i
                  className="fa fa-calendar-check-o"
                  id="item-programacao"
                  style={{ fontSize: "22px" }}
                ></i>
              </span>
              &nbsp;&nbsp;
              <span className="menu-title">Programação</span>
              <UncontrolledTooltip
                placement="right"
                target={`item-programacao`}
              >
                Programação
              </UncontrolledTooltip>
            </Link>
          </li> */}

          {/* <li
            className={`nav-item ${
              props.itemActive === "mensageria" ? "active" : ""
            }`}
          >
            <Link className="nav-link" to="/mensageria">
              <span style={{ minWidth: "30px", textAlign: "center" }}>
                <i className="fa fa-envelope" style={{ fontSize: "22px" }}></i>
              </span>
              &nbsp;&nbsp;
              <span className="menu-title">Mensageria</span>
            </Link>
          </li> */}

          {/* <li
            className={`nav-item ${
              props.itemActive === "comissao" ? "active" : ""
            }`}
          >
            <Link className="nav-link" to="/comissao">
              <span style={{ minWidth: "30px", textAlign: "center" }}>
                <i
                  className="fa fa-dollar"
                  id="item-comissao"
                  style={{ fontSize: "22px" }}
                ></i>
              </span>
              &nbsp;&nbsp;
              <span className="menu-title">Comissão</span>
              <UncontrolledTooltip placement="right" target={`item-comissao`}>
                Comissão
              </UncontrolledTooltip>
            </Link>
          </li> */}

          {/* <li
            className={`nav-item ${
              props.itemActive === "consulta-inteligente" ? "active" : ""
            }`}
          >
            <Link className="nav-link" to="/consulta-inteligente">
              <span style={{ minWidth: "30px", textAlign: "center" }}>
                <i
                  className="fa fa-dashboard"
                  id="consulta-inteligente"
                  style={{ fontSize: "22px" }}
                ></i>
              </span>
              &nbsp;&nbsp;
              <span className="menu-title">Consulta Inteligente</span>
              <UncontrolledTooltip
                placement="right"
                target={`consulta-inteligente`}
              >
                Consulta Inteligente
              </UncontrolledTooltip>
            </Link>
          </li> */}

          {/* <li
            className={`nav-item ${
              props.itemActive === "nova-agenda" ? "active" : ""
            }`}
          >
            <Link className="nav-link" to="/agenda-nova">
              <span style={{ minWidth: "30px", textAlign: "center" }}>
                <i
                  className="fa fa-calendar-o"
                  id="agenda-nova"
                  style={{ fontSize: "22px" }}
                ></i>
              </span>
              &nbsp;&nbsp;
              <span className="menu-title">Nova Agenda</span>
              <UncontrolledTooltip placement="right" target={`agenda-nova`}>
                Nova Agenda
              </UncontrolledTooltip>
            </Link>
          </li> */}

          {/* <li
            className={`nav-item ${
              props.itemActive === "relatorio-agenda" ? "active" : ""
            }`}
          >
            <Link className="nav-link" to="/agendas">
              <span style={{ minWidth: "30px", textAlign: "center" }}>
                <i
                  className="fa fa-clipboard"
                  id="relatorio-agenda"
                  style={{ fontSize: "22px" }}
                ></i>
              </span>
              &nbsp;&nbsp;
              <span className="menu-title">Agendas</span>
              <UncontrolledTooltip
                placement="right"
                target={`relatorio-agenda`}
              >
                Agendas
              </UncontrolledTooltip>
            </Link>
          </li> */}

          {itensMenu.includes("/usuarios-novo") && (
            <li
              className={`nav-item ${
                props.itemActive === "usuarios-novo" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/usuarios-novo">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-user-plus"
                    id="usuarios-novo"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Novo Usuário</span>
                <UncontrolledTooltip placement="right" target={`usuarios-novo`}>
                  Novo Usuário
                </UncontrolledTooltip>
              </Link>
            </li>
          )}

          {itensMenu.includes("/empresas") && (
            <li
              className={`nav-item ${
                props.itemActive === "empresas" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/empresas">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-bank"
                    id="consulta-empresas"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Empresas</span>
                <UncontrolledTooltip
                  placement="right"
                  target={`consulta-empresas`}
                >
                  Empresas
                </UncontrolledTooltip>
              </Link>
            </li>
          )}
          {itensMenu.includes("/usuarios") && (
            <li
              className={`nav-item ${
                props.itemActive === "usuarios" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/usuarios">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-users"
                    id="consulta-usuarios"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Usuários</span>
                <UncontrolledTooltip
                  placement="right"
                  target={`consulta-usuarios`}
                >
                  Usuários
                </UncontrolledTooltip>
              </Link>
            </li>
          )}

          {itensMenu.includes("/relatorios") && (
            <li
              className={`nav-item ${
                props.itemActive === "abc-cliente" ||
                props.itemActive === "abc-produto"
                  ? "active"
                  : ""
              }`}
              onClick={(e) => setMenuRelatoriosAberto(!menuRelatoriosAberto)}
              id="item-menu-relatorios"
              style={{ display: exibirRelatoriosAgrupados ? "block" : "none" }}
            >
              <a className="nav-link" style={{ cursor: "pointer" }}>
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-print"
                    id="item-relatorios"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Relatórios</span>
                &nbsp;&nbsp; &nbsp;&nbsp;<i className="fa fa-chevron-down"></i>
                <UncontrolledTooltip
                  placement="right"
                  target={`item-relatorios`}
                >
                  Relatórios
                </UncontrolledTooltip>
              </a>
              <div
                className={`${
                  menuRelatoriosAberto === true ? "" : "collapse"
                } `}
                id="auth"
              >
                <ul className="nav flex-column sub-menu">
                  <li
                    className={`nav-item ${
                      props.itemActive === "dashboard" ? "active" : ""
                    }`}
                  >
                    {" "}
                    <Link className="nav-link" to="/abc-clientes">
                      {" "}
                      ABC de Clientes{" "}
                    </Link>
                  </li>
                  <li
                    className={`nav-item ${
                      props.itemActive === "dashboard" ? "active" : ""
                    }`}
                  >
                    {" "}
                    <Link className="nav-link" to="/abc-produtos">
                      {" "}
                      ABC de Produtos{" "}
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          )}

          {itensMenu.includes("/relatorios") && (
            <li
              className={`nav-item ${
                props.itemActive === "abc-cliente" ? "active" : ""
              }`}
              id="item-menu-abc-clientes"
              style={{ display: exibirRelatoriosAgrupados ? "none" : "block" }}
            >
              <Link className="nav-link" to="/abc-clientes">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-print"
                    id="item-abc-clientes"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">ABC de Clientes</span>
                <UncontrolledTooltip
                  placement="right"
                  target={`item-abc-clientes`}
                >
                  ABC de Clientes
                </UncontrolledTooltip>
              </Link>
            </li>
          )}

          {itensMenu.includes("/relatorios") && (
            <li
              className={`nav-item ${
                props.itemActive === "abc-produto" ? "active" : ""
              }`}
              id="item-menu-abc-produtos"
              style={{ display: exibirRelatoriosAgrupados ? "none" : "block" }}
            >
              <Link className="nav-link" to="/abc-produtos">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-print"
                    id="item-abc-produtos"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">ABC de Produtos</span>
                <UncontrolledTooltip
                  placement="right"
                  target={`item-abc-produtos`}
                >
                  ABC de Produtos
                </UncontrolledTooltip>
              </Link>
            </li>
          )}

          {itensMenu.includes("/perfis") && (
            <li
              className={`nav-item ${
                props.itemActive === "perfis" ? "active" : ""
              }`}
            >
              <Link className="nav-link" to="/perfis">
                <span style={{ minWidth: "30px", textAlign: "center" }}>
                  <i
                    className="fa fa-users"
                    id="perfil-usuarios"
                    style={{ fontSize: "22px" }}
                  ></i>
                </span>
                &nbsp;&nbsp;
                <span className="menu-title">Perfis de Usuário</span>
                <UncontrolledTooltip
                  placement="right"
                  target={`perfil-usuarios`}
                >
                  Perfis de Usuário
                </UncontrolledTooltip>
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </React.Fragment>
  );
}
